import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Material Design Modules
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';

// Components
import { PlanComponent } from './plan.component';
import { PlanEditComponent } from '../plan-edit/plan-edit.component';
import { RoomIndikatorenListComponent } from '../components/room-indikatoren-list/room-indikatoren-list.component';
import { InteractivePlanModule } from '../components/interactive-plan/interactive-plan.module';
import { EditIndicatorDialogModule } from '../components/objekt-struktur-treetable/edit-indicator-dialog/edit-indicator-dialog.module';

// Routing
import { PlanRoutingModule } from './plan-routing.module';

// Services
import { PlanService } from '../services/plan.service';

@NgModule({
  declarations: [
    PlanComponent,
    PlanEditComponent,
    RoomIndikatorenListComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    PlanRoutingModule,
    MatPaginatorModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatTabsModule,
    MatSnackBarModule,
    MatDialogModule,
    EditIndicatorDialogModule,
    InteractivePlanModule
  ],
  exports: [
    PlanComponent,
    PlanEditComponent
  ],
  providers: [
    PlanService
  ]
})
export class PlanModule { }
